import {
    useAddGiftsToCartMutation,
    useAvailableGiftsInCartLazyQuery,
    useProductDetailGiftLazyQuery,
} from '@/framework/gql/gifts.graphql';
import {PickedGiftInput} from '__generated__/__types__';
import {getMagentoGraphqlApiEndpointPublic} from '@/framework/client';

export function useProductDetailGift() {
    const [getProductDetailGiftQuery, {data, loading, error}] = useProductDetailGiftLazyQuery();
    const getProductDetailGift = (productId: number) => {
        getProductDetailGiftQuery({
            variables: {
                productId,
            },
            context: {
                uri: getMagentoGraphqlApiEndpointPublic(),
            },
        });
    };
    return {
        getProductDetailGift,
        gifts: data?.freeGifts?.items ?? [],
        loading,
        error,
    };
}

export function useFreeGiftCart() {
    const [getProductDetailGiftQuery, {data, loading, error}] = useProductDetailGiftLazyQuery();
    const getProductDetailGift = (productId: number) => {
        getProductDetailGiftQuery({
            variables: {
                productId,
            },
            context: {
                uri: getMagentoGraphqlApiEndpointPublic(),
            },
        });
    };
    return {
        getProductDetailGift,
        data,
        loading,
        error,
    };
}

export function useAddGiftsToCart() {
    const [addGiftsToCartMutation, {data, loading, error}] = useAddGiftsToCartMutation();

    const addGiftsToCartServerSideAsync = (cartId: string, cartItemId: number, pickedGift: PickedGiftInput[]) => {
        return addGiftsToCartMutation({
            variables: {
                input: {
                    cart_id: cartId,
                    cart_item_id: cartItemId,
                    picked_gifts: pickedGift,
                },
            },
            context: {
                uri: getMagentoGraphqlApiEndpointPublic(),
            },
        });
    };

    const addGiftsToCartServerSide = (cartId: string, cartItemId: number, pickedGift: PickedGiftInput[]) => {
        addGiftsToCartServerSideAsync(cartId, cartItemId, pickedGift);
    };

    return {
        addGiftsToCartServerSide,
        addGiftsToCartServerSideAsync,
        data,
        loading,
        error,
    };
}

export function useAvailableGiftsInCart() {
    const [getAvailableGiftsInCartLazyQuery, {data, loading, error}] = useAvailableGiftsInCartLazyQuery();

    const getAvailableGiftsInCart = (cart_id: string) => {
        getAvailableGiftsInCartLazyQuery({
            variables: {
                cartId: cart_id,
            },
            fetchPolicy: 'no-cache',
            context: {
                uri: getMagentoGraphqlApiEndpointPublic(),
            },
        });
    };

    return {
        getAvailableGiftsInCart,
        availableGifts: data?.availableGiftsCart?.items ?? [],
        loading,
        error,
    };
}
